import { render, staticRenderFns } from "./donor-temporary.vue?vue&type=template&id=65ef1889&"
import script from "./donor-temporary.vue?vue&type=script&lang=js&"
export * from "./donor-temporary.vue?vue&type=script&lang=js&"
import style0 from "./donor-temporary.vue?vue&type=style&index=0&id=65ef1889&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports